import config from "../../src/common/default_config";

export default class options extends config {
  static page_ratio = 1.4925;
  static page_width_reference = 100000;
  static page_height_reference = 100000;
  static editor = "Advance Local Media";
  static subscriptionOptions = {
    subscriptionType: "subscription",
    subscriptionProvider: "ALO",
  };
  static pdfDownloadButtonsConfig = {
    ...config.pdfDownloadButtonsConfig,
    touchDownloadPdf: true,
  };
  static shareFromReader = true;

  static turnOnHeaderHelp = true;
  static displayTopNavButtonlabel = false;
  static topNavButtonLabel = "Activate/Subscribe";
  static toggleSubscriptionTopNavButtonOnUserLoggedIn = true;
  static singlePageView = false;

  //pdf
  static usePdfDesktop = true;
  static usePdfPhoneNot = [
    ["Safari", "iOS", "version_8"],
    ["Safari", "iOS", "version_7"],
  ];
  static usePdfPhone = true;
  static usePdfTabletNot = [
    ["Safari", "iOS", "version_8"],
    ["Safari", "iOS", "version_7"],
  ];
  static usePdfTablet = true;
  static replicaReadingModeToggle = {
    phone: false,
    tablet: true,
    desktop: true,
  };
  static replicaReadingModeDefault = {
    phone: false,
    tablet: false,
    desktop: false,
  };
  static displayPublicationNameInSidebar = true;
  static displayViewerOptions = true;
  static useCustomTooltips = false;
  static extraLinkDirectAccess = true;
  static shareFromReader = true;
  static shareFromNextgen = true;
  static displayPublicationNameInSidebar = true;
  static sharingOptions = {
    Facebook: true,
    WhatsApp: true,
    TwitterX: true,
    Mail: true,
    MailSubject: null,
    MailSubjectIntro: "Read From The Oregonian - ",
    useArticleMainImageInReplica: true,
  };
  static product_name_for_engage_readers = "Daily";
  static socialSharingHash = "social";
  static printCroppedPdf = true;
  static defaultPreferredViewer = "replica";
  static openHelpOnNewtab = true;
  static useSliderForPromospot = true;
  static useSliderForHorsSeries = true;
  static useSliderForArchive = true;
  static archiveLength = 60;

  // SSO
  static SSOEnabled = true;
  static paywallRedirectionUrl = true;
  static getSSOTokenFromUrl = true;
  static urlSSOTokenParameter = "code";
  static externalPaywallMaxRedirectionNumber = 5;
  static generateSSOState = true;

  // voucher
  static voucher = {
    ...config.voucher,
    isEnabled: true,
    dateFormat: "DD/MM/YYYY",
  };
}



// WEBPACK FOOTER //
// ./clients/ALO-OPC/config.js